import React from "react"
import { withStyles } from "@material-ui/core/styles"
/* eslint-disable import/first */ // これを入れないビルドが通らない
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

const styles = theme => ({
})

class ManagementIndexGraph extends React.Component {
  constructor(props) {
    super(props);
    const { items } = this.props;

    this.state = {
      graphItems: items.slice(-5), // 5年分を取得
    }
  }

  digitToJapaneseUnit = (number) => {
    // 万
    const tenThousand = 10**4;
    // 億
    const hundredMillion = tenThousand * 10**4;
    // 兆
    const trillion = hundredMillion * 10**4;

    if (number >= trillion) {
      return Math.round(number / trillion * 100) / 100 + "兆";
    } else if (number >= hundredMillion) {
      return Math.round(number / hundredMillion * 100) / 100 + "億";
    } else if (number >= tenThousand) {
      return Math.round(number / tenThousand * 100) / 100 + "万";
    } else {
      return Math.round(number);
    }
  }

  render() {
    const labels = this.state.graphItems.map(graphItem => graphItem['year'] + "年");
    const numberOfEmployees = this.state.graphItems.map(graphItem => graphItem['number_of_employees']);
    const amountOfSales = this.state.graphItems.map(graphItem => graphItem['amount_of_sales']);
    const capitalStock = this.state.graphItems.map(graphItem => graphItem['capital_stock']);

    const existNumberOfEmployees = !numberOfEmployees.every(function(item) { return item === null });
    const existAmountOfSales = !amountOfSales.every(function(item) { return item === null });
    const existCapitalStock = !capitalStock.every(function(item) { return item === null });

    let datasets = [];
    if (existCapitalStock) {
      datasets.push(
        {
          label: '資本金',
          stepped: true, // 階段状の線
          fill: true,
          backgroundColor: 'rgba(235, 235, 235, 0.3)',
          borderColor: '#CCCCCC',
          borderWidth: 1,
          pointRadius: 0,
          data: capitalStock,
          yAxisID: 'capital-stock-y-axis',
        }
      )
    }

    if (existAmountOfSales) {
      datasets.push(
        {
          label: '売上高',
          fill: false,
          lineTension: 0,
          backgroundColor: '#603CC3',
          borderColor: '#603CC3',
          borderWidth: 1,
          pointBorderColor: '#603CC3',
          pointBackgroundColor: '#603CC3',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointRadius: 2,
          pointHitRadius: 10,
          data: amountOfSales,
          yAxisID: 'amount-of-sales-y-axis',
        }
      )
    }

    if (existNumberOfEmployees) {
      datasets.push(
        {
          label: '従業員数',
          fill: false,
          lineTension: 0,
          backgroundColor: '#0CB7D6',
          borderColor: '#0CB7D6',
          borderWidth: 1,
          pointBorderColor: '#0CB7D6',
          pointBackgroundColor: '#0CB7D6',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointRadius: 2,
          pointHitRadius: 10,
          data: numberOfEmployees,
          yAxisID: 'number-of-employees-y-axis',
        },
      )
    }

    // datasets
    const info = {
      labels: labels,
      datasets: datasets,
    }

    const options = {
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          position: 'bottom', // 凡例を非表示
          onClick: function () { return false } // クリックしたら、非表示/表示が切り替わるのでfalseで防ぐ
        }
      },
      scales: {
        x: {
          grid :{
            drawTicks: false,
          },
          ticks: {
            padding: 10, // グラフとラベルとの距離
            font: function(context) {
              const width = context.chart.width;
              return {
                size: width > 400 ? 12 : 8,
              };
            },
          },
        },
        "number-of-employees-y-axis": {
          display: existNumberOfEmployees,
          type: "linear",
          position: "right",
          suggestedMin: 0,
          grid :{
            drawTicks: false, // グラフの端の補助線を表示しない
          },
          ticks: {
            count: 9,
            padding: 10,
            color: '#0CB7D6',
            callback: (number) => {
              return this.digitToJapaneseUnit(number);
            },
            font: function(context) {
              const width = context.chart.width;
              return {
                size: width > 400 ? 12 : 8,
              };
            },
          }
        },

        "amount-of-sales-y-axis": {
          display: existAmountOfSales,
          type: "linear",
          position: "left",
          suggestedMin: 0, // 0から始める
          grid :{
            drawTicks: false, // グラフの端の補助線を表示しない
          },
          ticks: {
            count: 9, // 0を含めたメモリの個数
            padding: 10,
            color: '#603CC3',
            callback: (number) => {
              return this.digitToJapaneseUnit(number);
            },
            font: function(context) {
              const width = context.chart.width;
              return {
                size: width > 400 ? 12 : 8,
              };
            },
          }
        },

        "capital-stock-y-axis": {
          display: existCapitalStock,
          type: "linear",
          position: "left",
          suggestedMin: 0, // 0から始める
          grid :{
            drawBorder: false, // 軸を表示しない
            drawTicks: false, // グラフの端の補助線を表示しない
          },
          ticks: {
            count: 9,
            padding: 10,
            callback: (number) => {
              return this.digitToJapaneseUnit(number);
            },
            font: function(context) {
              const width = context.chart.width;
              return {
                size: width > 400 ? 12 : 8,
              };
            },
          }
        },
      }
    }

    return (
      <Line height={180} data={info} options={options} />
    )
  }
}

ManagementIndexGraph.propTypes = {
}

ManagementIndexGraph.defaultProps = {
}

export default withStyles(styles)(ManagementIndexGraph)
